import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgForm,FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { CustomAutoCompleteModule } from '@module/custom-mat-autocomplete/custom-autocomplete.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { CustomInputTextboxModule } from '@module/custom-input-text/input-text.module';
import { CustomInputTextareaModule } from '@module/custom-input-textarea/input-textarea.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TransactionTabComponent } from '@pages/claimdashboard/tabs/transaction-tab/createedit/transaction-tab.component'

@NgModule({
  declarations: [
    TransactionTabComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatInputModule,
    CustomInputTextboxModule,
    CustomInputTextareaModule,
    MatFormFieldModule,
    CustomAutoCompleteModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MatTableModule,
   MatSelectModule,
   ],
  exports: [
    TransactionTabComponent
  ],
})

export class TransactionTabModule {
}
